import { Autocomplete, Box, TextField, Typography } from "@mui/material";
import React from "react";

const ExpenseTab = ({
    description,
    setDescription,
    amount,
    setAmount,
    selectedExpenseAccount,
    setSelectedExpenseAccount,
    expenseAccounts,
}) => {
    return (
        <>
            <TextField
                label="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                fullWidth
                margin="normal"
                variant="standard"
                required
            />
            <TextField
                label="Amount"
                type="number"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                fullWidth
                margin="normal"
                variant="standard"
                inputProps={{ min: 0, step: 0.01 }}
                required
            />
            <Autocomplete
                options={expenseAccounts || []}
                getOptionLabel={(option) => option.account_name || option.name}
                value={
                    expenseAccounts?.find(
                        (acc) => acc.name === selectedExpenseAccount
                    ) || null
                }
                onChange={(event, newValue) => {
                    setSelectedExpenseAccount(newValue?.name || "");
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Expense Account"
                        variant="standard"
                        margin="normal"
                        required
                        fullWidth
                    />
                )}
                renderOption={(props, option) => (
                    <Box component="li" {...props}>
                        <Typography variant="body2">
                            {option.account_name || option.name}
                        </Typography>
                    </Box>
                )}
            />
        </>
    );
};

export default ExpenseTab;
